export function isChrome() {
  const userAgent = (navigator && (navigator.userAgent || '')).toLowerCase();
  const vendor = (navigator && (navigator.vendor || '')).toLowerCase();
  const match = /google inc/.test(vendor) ? userAgent.match(/(?:chrome|crios)\/(\d+)/) : null;
  return match !== null;
}
